// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:41:52

export default {
  "id": "bouncy-barn",
  "slug": "bouncy-barn",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c01a7e40762d4f0f9aef1be852a487df-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c01a7e40762d4f0f9aef1be852a487df/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bouncy Barn",
      "description": "Bouncy Barn is a lively farm simulation game where players explore the charming world of farm life. Care for cute animals like chickens, cows, and goats. \n\nFeed and nurture your animals to keep them happy, and in return, they’ll provide valuable produce like eggs and milk. Harvest these goodies and sell them at the market to earn profits for expanding and upgrading your farm. With vibrant graphics and engaging gameplay, Bouncy Barn provides a fun escape to create your dream farm!",
      "instructions": "Mouse to Play",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "activity",
        "animal",
        "business",
        "farm"
      ]
    },
    "zh-CN": {
      "title": "弹跳农场",
      "description": "Bouncy Barn是一款充满活力的农场模拟游戏，玩家可以探索迷人的农场生活世界。照顾可爱的小动物，如鸡、牛和山羊。\n\n喂养和培育你的动物以保持它们的快乐，作为回报，它们将提供有价值的农产品，如鸡蛋和牛奶。收获这些美食并在市场上出售，以赚取利润，用于扩展和升级你的农场。凭借鲜艳的图形和引人入胜的游戏玩法，Bouncy Barn为你提供了一个创建梦想农场的欢乐逃避！",
      "instructions": "鼠标操作",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "活动",
        "动物",
        "商业",
        "农场"
      ]
    },
    "zh-TW": {
      "title": "bouncey 冲刺的\nbarn 畜棚\n\n彈跳畜棚",
      "description": "Bouncy Barn是一款活躍的農場模擬遊戲，讓玩家探索迷人的農村生活。照顧可愛的動物，如雞、牛和山羊。\n\n喂飽和撫養你的動物，讓它們快樂，它們將回報你珍貴的產品，如雞蛋和牛奶。收穫這些美味，並在市場上賣出，以賺取資金來擴張和升級你的農場。Bouncy Barn以生動的圖像和吸引人的遊戲玩法，提供一個創造夢幻農場的樂趣逃逸！",
      "instructions": "滑鼠操控遊戲",
      "genres": [
        "休閒",
        "模擬"
      ],
      "tags": [
        "活動",
        "動物",
        "商業",
        "農場"
      ]
    },
    "zh-HK": {
      "title": "彈跳農場",
      "description": "Bouncy Barn 是一個生動的農場模擬遊戲，讓玩家探索迷人農場生活。照顧可愛的動物，如雞、牛和山羊。喂飽並培育你的動物，讓它們保持快樂，並以此換取寶貴的產品，如雞蛋和牛奶。收穫這些佳品並在市場上出售，以賺取利潤來擴大和升級你的農場。Bouncy Barn 透過生動的圖像和引人入勝的遊戲性，為玩家提供一個創造夢幻農場的愉快逃離！",
      "instructions": "滑鼠操作遊戲",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "活動",
        "動物",
        "商業",
        "農場"
      ]
    },
    "ja": {
      "title": "バンキーシーボー",
      "description": "バウンジ・バーンは、プレイヤーが魅力的な農村生活の世界を探検する活気ある農場シミュレーションゲームです。鶏、牛、山羊などの可愛い動物を世話してください。\n\n動物を餌や愛情で満たし、幸せに保ち、それに対し、彼らは貴重な生産物、例えば卵やミルクを提供します。これらの美味しいものを収穫し、市場で売って利益を得て、あなたの農場を拡張・向上させましょう。鮮やかなグラフィックと魅力的なゲームプレイで、バウンジ・バーンは夢の農場を作るための楽しい逃避現実です！",
      "instructions": "マウスで遊ぶ",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "アクティビティ",
        "動物",
        "ビジネス",
        "農場"
      ]
    },
    "ko": {
      "title": "봉봉농장",
      "description": "Bouncy Barn은 활기찬 농장 시뮬레이션 게임으로, 플레이어들이 농장 생활의 매력적인 세계를 탐험할 수 있습니다. 닭, 소, 양과 같은 귀여운 동물들을 돌봅니다.\n\n동물들을 먹이고 돌봐서 그들을 기쁘게 해주고, 그들도 계란과 우유와 같은 귀중한 생산물을 제공합니다. 이 맛있는 것들을 수확하여 시장에서 판매하여 농장을 확장하고 업그레이드하는 데 이익을 벌 수 있습니다. 생동감 넘치는 그래픽과 재미있는 게임플레이로 Bouncy Barn은 꿈의 농장을 만들기 위한 즐거운 탈출을 제공합니다!",
      "instructions": "마우스로 플레이",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "활동",
        "동물",
        "사업",
        "농장"
      ]
    },
    "fr": {
      "title": "Ferme rebondissante",
      "description": "Bouncy Barn est un jeu de simulation de ferme dynamique où les joueurs découvrent le charmant monde de la vie agricole. Prenez soin de petites bêtes mignonnes comme des poules, des vaches et des chèvres.\n\nAlimentez et soignez vos animaux pour les rendre heureux, et en retour, ils vous fourniront des produits précieux comme des œufs et du lait. Récoltez ces trésors et vendez-les sur le marché pour gagner des profits pour agrandir et améliorer votre ferme. Avec des graphismes vibrants et un gameplay captivant, Bouncy Barn offre un divertissement amusant pour créer votre ferme de rêve !",
      "instructions": "Souris pour jouer",
      "genres": [
        "Facile",
        "Simulation"
      ],
      "tags": [
        "activité",
        "animal",
        "entreprise",
        "ferme"
      ]
    }
  }
};
